import { render, staticRenderFns } from "./addcofig.vue?vue&type=template&id=5833c81e&"
import script from "./addcofig.vue?vue&type=script&lang=js&"
export * from "./addcofig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5833c81e')) {
      api.createRecord('5833c81e', component.options)
    } else {
      api.reload('5833c81e', component.options)
    }
    module.hot.accept("./addcofig.vue?vue&type=template&id=5833c81e&", function () {
      api.rerender('5833c81e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/globalcofig/addcofig.vue"
export default component.exports